<bn-loading-overlay></bn-loading-overlay>

<h5>Tarefas para verificação de inadimplência</h5>

<div class="container">
  <div ngbAccordion>

    <div ngbAccordionItem>
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton class="title2">Verificação de inadimplência de beneficiário</button>
      </h2>

      <div ngbAccordionCollapse>
			<div ngbAccordionBody>
      <ng-template>
        <div class="row">
          <div class="col-md-3">
            <label for="cpfOuCnpjBeneficiario">CPF/CNPJ do beneficiário:</label> 
            <input type="text" id="cpfOuCnpjBeneficiario" class="form-control" [(ngModel)]="cpfOuCnpjBeneficiario">
          </div>
        </div>
        <div class="row">
          <div class="submit col-auto">
            <button type="button" class="btn btn-success no-margin" (click)="verificarInadimplenciaBeneficiario()">Consultar</button>
          </div>
        </div>
      </ng-template>
    </div>
    </div>
    </div>

    <div ngbAccordionItem>
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton class="title2">Verificação de inadimplência de beneficiário no FGI Tradicional (sistema legado)</button>
      </h2>

      <div ngbAccordionCollapse>
			<div ngbAccordionBody>
      <ng-template>
        <div class="row">
          <div class="col-md-3">
            <label for="cpfOuCnpjBeneficiarioFgi">CPF/CNPJ do beneficiário:</label> 
            <input type="text" id="cpfOuCnpjBeneficiarioFgi" class="form-control" [(ngModel)]="cpfOuCnpjBeneficiario">
          </div>
        </div>
        <div class="row">
          <div class="submit col-auto">
            <button type="button" class="btn btn-success no-margin" (click)="verificarInadimplenciaBeneficiarioFgi()">Consultar</button>
          </div>
        </div>
      </ng-template>
    </div>
    </div>
    </div>

    <div ngbAccordionItem >
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton class="title2">Verificação de inadimplência de Agente Financeiro</button>
      </h2>

      <div ngbAccordionCollapse>
			<div ngbAccordionBody>
      <ng-template>
        <div class="row">
          <div class="col-md-3">
            <label for="cnpjAgenteFinanceiro">CNPJ do Agente Financeiro:</label> 
            <input type="text" id="cnpjAgenteFinanceiro" class="form-control" [(ngModel)]="cnpjAgenteFinanceiro">
          </div>
        </div>
        <div class="row">
          <div class="submit col-auto">
            <button type="button" class="btn btn-success no-margin" (click)="verificarInadimplenciaAgenteFinanceiro()">Consultar</button>
          </div>
        </div>
      </ng-template>
    </div>
    </div>
    </div>

    <div ngbAccordionItem >
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton class="title2">Verificação de inadimplência financeira de Agente Financeiro no FGI Tradicional (sistema legado)</button>
      </h2>

      <div ngbAccordionCollapse>
			<div ngbAccordionBody>
      <ng-template>
        <div class="row"> 
          <div class="col-md-3">
            <label for="cnpjAgenteFinanceiroFgi">CNPJ do Agente Financeiro:</label> 
            <input type="text" id="cnpjAgenteFinanceiroFgi" class="form-control" [(ngModel)]="cnpjAgenteFinanceiro">
          </div>
        </div>
        <div class="row">
          <div class="submit col-auto">
            <button type="button" class="btn btn-success no-margin" (click)="verificarInadimplenciaFinanceiraAgenteFinanceiroNoFgi()">Consultar</button>
          </div>
        </div>
      </ng-template> 
    </div>
    </div>
    </div>
  </div>
</div>